import SponsorPurchasesDashboard from './SponsorPurchasesDashboard';
export default SponsorPurchasesDashboard;